import React, { useState, useEffect } from 'react';

function Navigation() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <a href="/" className="nav-logo" aria-label="CerebralMachines home">
          <img src="/CMLogo.png" alt="CerebralMachines" />
        </a>

        <div className="nav-links">
          <a href="#platform">Platform</a>
          <a href="#how-it-works">How It Works</a>
          <a href="#use-cases">Use Cases</a>
          <a href="#docs">Docs</a>
        </div>

        <div className="nav-actions">
          <a href="/login">
            <button className="btn-secondary">Sign In</button>
          </a>
          <a href="/signup">
            <button className="btn-primary">Request Access</button>
          </a>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;

